// @ts-nocheck
//import "@babel/polyfill";
//import "custom-event-polyfill";
//import 'react-app-polyfill/ie11';

//import '../node_modules/jquery/dist/jquery.min';
//import '../node_modules/bootstrap/dist/js/bootstrap.min';
//import './css/all.min.css';
//import './css/font-awesome.min.css';
//import './css/bootstrap.min.css';
//import './css/bootstrap-datetimepicker.min.css';
//import './css/site.css';

import './../../ClientApp/node_modules/bootstrap/dist/css/bootstrap.min.css';
import "./../../ClientApp/node_modules/react-datepicker/dist/react-datepicker.css";
//import './css/bootstrap-datetimepicker.min.css';
import './css/CustomStyleSheet.min.css';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import Chromepng from './images/Chrome.png';
import Edgepng from './images/Edge.png';
import Firefoxpng from './images/Firefox.png';
import configureStore from './store/configureStore';
import registerServiceWorker from './registerServiceWorker';
import { ApplicationState } from './store';
import * as RoutesModule from './routes';
import { persistStore } from 'redux-persist';
import OktaApp from './OktaApp';
import AzureApp from './AzureApp';
import AzureADRedirectApp from './AzureADRedirectApp';
import { OktaAuth } from "@okta/okta-auth-js";
import OktatoRCRedirect from "./components/routecomponents/OktatoRCRedirect";
import OktaNoAccount from "./components/routecomponents/OktaNoAccount";
import Auth0NoRegion from "./components/routecomponents/Auth0NoRegion";
import { PublicClientApplication, EventType } from '@azure/msal-browser';
//import { getConfig } from "./OauthConfig";
import { Auth0Provider } from "@auth0/auth0-react";
import { BrowserRouter } from "react-router-dom";
import { Auth0ProviderWithHistory } from "./Auth0ProviderWithHistory";
import { Auth0ProviderWithHistoryEU } from "./Auth0ProviderWithHistoryEU";
import { Auth0ProviderWithHistoryUS } from "./Auth0ProviderWithHistoryUS";
import { Auth0ProviderWithHistoryJP } from "./Auth0ProviderWithHistoryJP";
import { Auth0ProviderWithHistoryUK } from "./Auth0ProviderWithHistoryUK";
import { Auth0ProviderWithHistoryAU } from "./Auth0ProviderWithHistoryAU";
import { Auth0ProviderWithHistoryCA } from "./Auth0ProviderWithHistoryCA";
import OAuthApp from "./OAuthApp";
import OAuthEUApp from "./OAuthEUApp";
import OAuthUSApp from "./OAuthUSApp";
import OAuthJPApp from "./OAuthJPApp";
import OAuthUKApp from "./OAuthUKApp";
import OAuthAUApp from "./OAuthAUApp";
import OAuthCAApp from "./OAuthCAApp";

const $ = require('jquery');
var Config: any = require('./Config.json');

let oktabaseURI = window.location.href;
var lastTagName = oktabaseURI.split("/").pop();
var auth0Domain = Config.OAuthDomain_US;
var validKeyWords = Config.ValidOAuthKeyWords.split(",");
var isTagValid = validKeyWords.includes(lastTagName);
if (isTagValid) {
    sessionStorage.setItem('KeyWord', lastTagName);
}
// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
const history = createBrowserHistory({ basename: baseUrl });
//const config = getConfig();
const onRedirectCallback = (appState) => {
    history.push(
        appState && appState.returnTo ? appState.returnTo : window.location.pathname
    );
};

function detectIE() {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1;
    const edge = ua.indexOf('Edge/') > -1;
    return msie || edge;
}

if (detectIE()) {
    $("body").css("background-color", "white !important");
    var preloader = document.getElementById("preloader");
    preloader.classList.add("hidden");
    ReactDOM.render(<div className='font-size-20 text-align-center iE_error'>

        <div className='font-size-30'> ReeferConnect no longer supports Internet Explorer </div>

        <div className='font-size-20 mt-2'> Please use one of these browsers </div>
        <div>
            <table className='browsericons'>
                <tbody><tr>
                    <th className="bsChrome" title="Chrome"><img src={Chromepng} className='Chrome_img' /></th>
                    <th className="bsEdge" title="Edge">  <img src={Edgepng} className='Edge_img' /></th>
                    <th className="bsFirefox" title="Firefox"><img src={Firefoxpng} className='Firefox_img' /> </th>
                </tr>
                    <tr>
                        <td>Chrome</td>
                        <td>Edge</td>
                        <td>Firefox</td>
                    </tr>
                </tbody></table>
        </div>



    </div>,


        document.getElementById('root'));
}
else {
    if (lastTagName.indexOf('sso') === -1 && sessionStorage.getItem('azureInit') == null && lastTagName.indexOf('adlogin') === -1 && lastTagName.indexOf('#code=') === -1 && validKeyWords.indexOf(sessionStorage.getItem('KeyWord')) !== -1 || lastTagName.indexOf('callback') !== -1 || sessionStorage.getItem('okta-token-storage') != null) {
        // Get the application-wide store instance, prepopulating with state from the server where available.
        const store = configureStore(history);
        let keyWord = sessionStorage.getItem('KeyWord');
        let fromISS = false;
        if (lastTagName.indexOf('callback?iss') !== -1 && keyWord == null) {
            // from tile with iss value
            fromISS = true;
            sessionStorage.setItem('OIN', 'True');
            keyWord = oktabaseURI.split("/").pop().split("?")[1].substr(4);
        }
        if (!sessionStorage.getItem("oData")) {
            if (!sessionStorage.getItem("UserInfo") == null) //RCNG-207
            {
                persistStore(store, {}).purge();
            }
            const TemplateUrl = Config.ApiBaseUrl + '/api/User/GetOktaConfigValue?TagName=' + keyWord;
            var requestHeaders = new Headers();
            requestHeaders.append('pragma', 'no-cache');
            requestHeaders.append('cache-control', 'no-cache');
            requestHeaders.append('Accept', 'application/json');
            requestHeaders.append('Content-Type', 'application/json');
            fetch(TemplateUrl, {
                method: 'GET',
                headers: requestHeaders,
            })
                .then(response => response.json() as Promise<any>)
                .then(data => {
                    if ((data != null && data.Client_id != null) || (data != null && data.Issuer != null)) {
                        if (fromISS) {
                            if ((data.Urlpath != '') && (data.Urlpath != ' ') && (data.Urlpath != null)) {
                                sessionStorage.setItem('KeyWord', data.Urlpath);
                                history.replace("/" + data.Urlpath);
                                sessionStorage.setItem('oData', JSON.stringify(data));
                                if ((data.Oktasigninoption == 'A') || (data.Oktasigninoption == 'R')) {
                                    const oktaAuth = new OktaAuth({
                                        issuer: data.Issuer,
                                        redirectUri: `${window.location.origin}/implicit/callback`,
                                        clientId: data.Client_id,
                                        tokenManager: {
                                            storage: 'sessionStorage'
                                        },
                                        storageManager: {
                                            token: {
                                                storageType: 'sessionStorage',
                                                storageTypes: []
                                            },
                                            cache: {
                                                storageType: 'sessionStorage',
                                                storageTypes: []
                                            },
                                            transaction: {
                                                storageType: 'sessionStorage',
                                                storageTypes: []
                                            }
                                        }
                                    });
                                    oktaAuth.tokenManager.on('error', function (err) {
                                        if (err.errorCode === 'login_required') {
                                            //window.location.href = "Unauthorized";
                                            history.replace('/unauthorized');
                                        }
                                    });
                                    sessionStorage.setItem('UrlPath', data.Urlpath);

                                    ReactDOM.render(
                                        <Provider store={store}>
                                            <ConnectedRouter history={history}>
                                                <OktaApp auth={oktaAuth} />
                                            </ConnectedRouter>
                                        </Provider>,
                                        document.getElementById('root'));

                                }
                                else {
                                    var preloader = document.getElementById("preloader");
                                    preloader.classList.add("hidden");

                                    ReactDOM.render(<OktatoRCRedirect />, document.getElementById('root'));
                                }
                            }
                            else {
                                var preloader = document.getElementById("preloader");
                                preloader.classList.add("hidden");

                                ReactDOM.render(<OktaNoAccount />, document.getElementById('root'));
                            }
                            return;
                        }
                        sessionStorage.setItem('oData', JSON.stringify(data));
                        if ((data.Oktasigninoption == 'A') || (data.Oktasigninoption == 'R')) {
                            const oktaAuth = new OktaAuth({
                                issuer: data.Issuer,
                                redirectUri: `${window.location.origin}/implicit/callback`,
                                clientId: data.Client_id,
                                tokenManager: {
                                    storage: 'sessionStorage'
                                },
                                storageManager: {
                                    token: {
                                        storageType: 'sessionStorage',
                                        storageTypes: []
                                    },
                                    cache: {
                                        storageType: 'sessionStorage',
                                        storageTypes: []
                                    },
                                    transaction: {
                                        storageType: 'sessionStorage',
                                        storageTypes: []
                                    }
                                }
                            });

                            oktaAuth.tokenManager.on('error', function (err) {
                                if (err.errorCode === 'login_required') {
                                    //window.location.href = "Unauthorized";
                                    history.replace('/unauthorized');
                                }
                            });
                            sessionStorage.setItem('UrlPath', data.Urlpath);

                            ReactDOM.render(
                                <Provider store={store}>
                                    <ConnectedRouter history={history}>
                                        <OktaApp auth={oktaAuth} />
                                    </ConnectedRouter>
                                </Provider>,
                                document.getElementById('root'));

                        }
                        else {
                            var preloader = document.getElementById("preloader");
                            preloader.classList.add("hidden");

                            ReactDOM.render(<OktatoRCRedirect />, document.getElementById('root'));
                        }
                    }
                    else {
                        var preloader = document.getElementById("preloader");
                        preloader.classList.add("hidden");

                        ReactDOM.render(<OktaNoAccount />, document.getElementById('root'));
                    }
                });
        }

        else if (sessionStorage.getItem("oData")) {
            var data = JSON.parse(sessionStorage.getItem("oData"));
            if ((data.Oktasigninoption == 'A') || (data.Oktasigninoption == 'R')) {
                const oktaAuth = new OktaAuth({
                    issuer: data.Issuer,
                    redirectUri: `${window.location.origin}/implicit/callback`,
                    clientId: data.Client_id,
                    tokenManager: {
                        storage: 'sessionStorage'
                    },
                    storageManager: {
                        token: {
                            storageType: 'sessionStorage',
                            storageTypes: []
                        },
                        cache: {
                            storageType: 'sessionStorage',
                            storageTypes: []
                        },
                        transaction: {
                            storageType: 'sessionStorage',
                            storageTypes: []
                        }
                    }
                });

                oktaAuth.tokenManager.on('error', function (err) {
                    if (err.errorCode === 'login_required') {
                        //window.location.href = "Unauthorized";
                        history.replace('/unauthorized');
                    }
                });
                sessionStorage.setItem('UrlPath', data.Urlpath);

                ReactDOM.render(
                    <Provider store={store}>
                        <ConnectedRouter history={history}>
                            <OktaApp auth={oktaAuth} />
                        </ConnectedRouter>
                    </Provider>,
                    document.getElementById('root'));

            }

        }

    }
    else if (oktabaseURI.split("/").pop() == 'unauthorized' || lastTagName !== '' && validKeyWords.indexOf(sessionStorage.getItem('KeyWord')) !== -1 || lastTagName.indexOf('adlogin') !== -1 || lastTagName.indexOf('#code=') !== -1 || lastTagName.indexOf('sso') !== -1) {
        if (lastTagName.indexOf('sso') !== -1 || sessionStorage.getItem('azureInit') != null) {
            const store = configureStore(history);
            const clientConfig = {
                auth: {
                    clientId: Config.AzureclientId,
                    authority: Config.Azureauthority,
                    navigateToLoginRequestUrl: true,
                    cache: {
                        cacheLocation: "localStorage",
                        storeAuthStateInCookie: false
                    }
                }
            }
            const msalInstance = new PublicClientApplication(clientConfig);
            if (msalInstance != null && msalInstance.getAllAccounts() != null && msalInstance.getAllAccounts().length > 0) {
                msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);

            }
            ReactDOM.render(
                <Provider store={store}>
                    <ConnectedRouter history={history}>
                        <AzureADRedirectApp instance={msalInstance} />
                    </ConnectedRouter>
                </Provider>,
                document.getElementById('root'));

        }
        else if (lastTagName.indexOf('adlogin') !== -1 || lastTagName.indexOf('#code =') === -1) {
            const store = configureStore(history);
            const clientConfig = {
                auth: {
                    clientId: Config.AzureclientId,
                    authority: Config.Azureauthority,
                    navigateToLoginRequestUrl: true,
                    cache: {
                        cacheLocation: "localStorage",
                        storeAuthStateInCookie: false
                    }
                }
            }
            const msalInstance = new PublicClientApplication(clientConfig);
            if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
                msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
            }

            // Optional - This will update account state if a user signs in from another tab or window
            msalInstance.enableAccountStorageEvents();
            const accounts = msalInstance.getAllAccounts();
            if (accounts.length > 0) {
                msalInstance.setActiveAccount(accounts[0]);
            }

            msalInstance.addEventCallback((event: any) => {
                if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
                    const payload = event.payload;
                    const account = payload.account;
                    msalInstance.setActiveAccount(account);
                }
            });
            ReactDOM.render(
                <Provider store={store}>
                    <ConnectedRouter history={history}>
                        <AzureApp instance={msalInstance} />
                    </ConnectedRouter>
                </Provider>,
                document.getElementById('root'));

        }
    }
    else if (lastTagName === "" || sessionStorage.getItem('okta-token-storage') == null || sessionStorage.getItem('azureInit') == null) {
        let routes = RoutesModule.routes;
        // Get the application-wide store instance, prepopulating with state from the server where available.
        const initialState = (window as any).initialReduxState as ApplicationState;
        const store = configureStore(history, initialState);

        function renderApp() {
            if (Config.EnableNativeLogin) {
                if (!sessionStorage.getItem("UserInfo") == null) {
                    persistStore(store, {}, () => {
                        persistStore(store, {}, () => {
                            ReactDOM.render(
                                <Provider store={store}>
                                    <ConnectedRouter history={history} children={routes} />
                                </Provider>,
                                document.getElementById('root')
                            );
                        });
                    }).purge();
                }
                else {
                    persistStore(store, {}, () => {
                        // This code starts up the React app when it runs in a browser. It sets up the routing configuration
                        // and injects the app into a DOM element.
                        ReactDOM.render(
                            <Provider store={store}>
                                <ConnectedRouter history={history} children={routes} />
                            </Provider>,
                            document.getElementById('root')
                        );
                    });
                }
            }
            else {
                if (lastTagName === "" || sessionStorage.getItem("OrbInit") == "self" ) {
                    if (!sessionStorage.getItem("UserInfo") == null) {
                        persistStore(store, {}, () => {
                            persistStore(store, {}, () => {
                                ReactDOM.render(
                                    <Provider store={store}>
                                        <ConnectedRouter history={history} children={routes} />
                                    </Provider>,
                                    document.getElementById('root')
                                );
                            });
                        }).purge();
                    }
                    else {
                        persistStore(store, {}, () => {
                            // This code starts up the React app when it runs in a browser. It sets up the routing configuration
                            // and injects the app into a DOM element.
                            ReactDOM.render(
                                <Provider store={store}>
                                    <ConnectedRouter history={history} children={routes} />
                                </Provider>,
                                document.getElementById('root')
                            );
                        });
                    }
                }
                else if (lastTagName === "eu" || lastTagName === "EU" || lastTagName.startsWith('EU?iss=') || sessionStorage.getItem("region") == "EU") {
                    sessionStorage.setItem('region', 'EU');
                    if (!sessionStorage.getItem("UserInfo") == null) {
                        persistStore(store, {}, () => {
                            persistStore(store, {}, () => {
                                ReactDOM.render(
                                    <Provider store={store}>
                                        <ConnectedRouter history={history}>
                                            <BrowserRouter>
                                                <Auth0ProviderWithHistoryEU>
                                                    <OAuthEUApp />
                                                </Auth0ProviderWithHistoryEU>
                                            </BrowserRouter>
                                        </ConnectedRouter>
                                    </Provider>,
                                    document.getElementById('root')
                                );
                            });
                        }).purge();
                    }
                    else {
                        persistStore(store, {}, () => {
                            // This code starts up the React app when it runs in a browser. It sets up the routing configuration
                            // and injects the app into a DOM element.
                            ReactDOM.render(
                                <Provider store={store}>
                                    <ConnectedRouter history={history}>
                                        <BrowserRouter>
                                            <Auth0ProviderWithHistoryEU >
                                                <OAuthEUApp />
                                            </Auth0ProviderWithHistoryEU>
                                        </BrowserRouter>
                                    </ConnectedRouter>
                                </Provider>,
                                document.getElementById('root')
                            );
                        });
                    }
                }
                else if (lastTagName === "jp" || lastTagName === "JP" || lastTagName.startsWith('JP?iss=') || sessionStorage.getItem("region") == "JP") {
                    sessionStorage.setItem('region', 'JP');
                    if (!sessionStorage.getItem("UserInfo") == null) {
                        persistStore(store, {}, () => {
                            persistStore(store, {}, () => {
                                ReactDOM.render(
                                    <Provider store={store}>
                                        <ConnectedRouter history={history}>
                                            <BrowserRouter>
                                                <Auth0ProviderWithHistoryJP>
                                                    <OAuthJPApp />
                                                </Auth0ProviderWithHistoryJP>
                                            </BrowserRouter>
                                        </ConnectedRouter>
                                    </Provider>,
                                    document.getElementById('root')
                                );
                            });
                        }).purge();
                    }
                    else {
                        persistStore(store, {}, () => {
                            // This code starts up the React app when it runs in a browser. It sets up the routing configuration
                            // and injects the app into a DOM element.
                            ReactDOM.render(
                                <Provider store={store}>
                                    <ConnectedRouter history={history}>
                                        <BrowserRouter>
                                            <Auth0ProviderWithHistoryJP >
                                                <OAuthJPApp />
                                            </Auth0ProviderWithHistoryJP>
                                        </BrowserRouter>
                                    </ConnectedRouter>
                                </Provider>,
                                document.getElementById('root')
                            );
                        });
                    }
                }
                else if (lastTagName === "uk" || lastTagName === "UK" || lastTagName.startsWith('UK?iss=') || sessionStorage.getItem("region") == "UK") {
                    sessionStorage.setItem('region', 'UK');
                    if (!sessionStorage.getItem("UserInfo") == null) {
                        persistStore(store, {}, () => {
                            persistStore(store, {}, () => {
                                ReactDOM.render(
                                    <Provider store={store}>
                                        <ConnectedRouter history={history}>
                                            <BrowserRouter>
                                                <Auth0ProviderWithHistoryUK>
                                                    <OAuthUKApp />
                                                </Auth0ProviderWithHistoryUK>
                                            </BrowserRouter>
                                        </ConnectedRouter>
                                    </Provider>,
                                    document.getElementById('root')
                                );
                            });
                        }).purge();
                    }
                    else {
                        persistStore(store, {}, () => {
                            // This code starts up the React app when it runs in a browser. It sets up the routing configuration
                            // and injects the app into a DOM element.
                            ReactDOM.render(
                                <Provider store={store}>
                                    <ConnectedRouter history={history}>
                                        <BrowserRouter>
                                            <Auth0ProviderWithHistoryUK >
                                                <OAuthUKApp />
                                            </Auth0ProviderWithHistoryUK>
                                        </BrowserRouter>
                                    </ConnectedRouter>
                                </Provider>,
                                document.getElementById('root')
                            );
                        });
                    }
                }
                else if (lastTagName === "au" || lastTagName === "AU" || lastTagName.startsWith('AU?iss=') || sessionStorage.getItem("region") == "AU") {
                    sessionStorage.setItem('region', 'AU');
                    if (!sessionStorage.getItem("UserInfo") == null) {
                        persistStore(store, {}, () => {
                            persistStore(store, {}, () => {
                                ReactDOM.render(
                                    <Provider store={store}>
                                        <ConnectedRouter history={history}>
                                            <BrowserRouter>
                                                <Auth0ProviderWithHistoryAU>
                                                    <OAuthAUApp />
                                                </Auth0ProviderWithHistoryAU>
                                            </BrowserRouter>
                                        </ConnectedRouter>
                                    </Provider>,
                                    document.getElementById('root')
                                );
                            });
                        }).purge();
                    }
                    else {
                        persistStore(store, {}, () => {
                            // This code starts up the React app when it runs in a browser. It sets up the routing configuration
                            // and injects the app into a DOM element.
                            ReactDOM.render(
                                <Provider store={store}>
                                    <ConnectedRouter history={history}>
                                        <BrowserRouter>
                                            <Auth0ProviderWithHistoryAU >
                                                <OAuthAUApp />
                                            </Auth0ProviderWithHistoryAU>
                                        </BrowserRouter>
                                    </ConnectedRouter>
                                </Provider>,
                                document.getElementById('root')
                            );
                        });
                    }
                }
                else if (lastTagName === "us" || lastTagName === "US" || lastTagName.startsWith('US?iss=') || sessionStorage.getItem("region") == "US") {
                    sessionStorage.setItem('region', 'US');
                    if (!sessionStorage.getItem("UserInfo") == null) {
                        persistStore(store, {}, () => {
                            persistStore(store, {}, () => {
                                ReactDOM.render(
                                    <Provider store={store}>
                                        <ConnectedRouter history={history}>
                                            <BrowserRouter>
                                                <Auth0ProviderWithHistoryUS>
                                                    <OAuthUSApp />
                                                </Auth0ProviderWithHistoryUS>
                                            </BrowserRouter>
                                        </ConnectedRouter>
                                    </Provider>,
                                    document.getElementById('root')
                                );
                            });
                        }).purge();
                    }
                    else {
                        persistStore(store, {}, () => {
                            // This code starts up the React app when it runs in a browser. It sets up the routing configuration
                            // and injects the app into a DOM element.
                            ReactDOM.render(
                                <Provider store={store}>
                                    <ConnectedRouter history={history}>
                                        <BrowserRouter>
                                            <Auth0ProviderWithHistoryUS>
                                                <OAuthUSApp />
                                            </Auth0ProviderWithHistoryUS>
                                        </BrowserRouter>
                                    </ConnectedRouter>
                                </Provider>,
                                document.getElementById('root')
                            );
                        });
                    }
                }
                else if (lastTagName === "ca" || lastTagName === "CA" || lastTagName.startsWith('CA?iss=') || sessionStorage.getItem("region") == "CA") {
                    sessionStorage.setItem('region', 'CA');
                    if (!sessionStorage.getItem("UserInfo") == null) {
                        persistStore(store, {}, () => {
                            persistStore(store, {}, () => {
                                ReactDOM.render(
                                    <Provider store={store}>
                                        <ConnectedRouter history={history}>
                                            <BrowserRouter>
                                                <Auth0ProviderWithHistoryCA>
                                                    <OAuthCAApp />
                                                </Auth0ProviderWithHistoryCA>
                                            </BrowserRouter>
                                        </ConnectedRouter>
                                    </Provider>,
                                    document.getElementById('root')
                                );
                            });
                        }).purge();
                    }
                    else {
                        persistStore(store, {}, () => {
                            // This code starts up the React app when it runs in a browser. It sets up the routing configuration
                            // and injects the app into a DOM element.
                            ReactDOM.render(
                                <Provider store={store}>
                                    <ConnectedRouter history={history}>
                                        <BrowserRouter>
                                            <Auth0ProviderWithHistoryCA>
                                                <OAuthCAApp />
                                            </Auth0ProviderWithHistoryCA>
                                        </BrowserRouter>
                                    </ConnectedRouter>
                                </Provider>,
                                document.getElementById('root')
                            );
                        });
                    }
                }
                else {
                    if (!sessionStorage.getItem("UserInfo") == null) {
                        persistStore(store, {}, () => {
                            persistStore(store, {}, () => {
                                ReactDOM.render(
                                    <Provider store={store}>
                                        <ConnectedRouter history={history} children={routes} />
                                    </Provider>,
                                    document.getElementById('root')
                                );
                            });
                        }).purge();
                    }
                    else {
                        persistStore(store, {}, () => {
                            // This code starts up the React app when it runs in a browser. It sets up the routing configuration
                            // and injects the app into a DOM element.
                            ReactDOM.render(
                                <Provider store={store}>
                                    <ConnectedRouter history={history} children={routes} />
                                </Provider>,
                                document.getElementById('root')
                            );
                        });
                    }
                }


            }
        }

        renderApp();
    }
}

registerServiceWorker();

